import { Button } from '../../components/ui/button';

export interface TabNotFoundProps {
  onGoBack: () => void;
}

/** In-shell 404 for a campaign tab that doesn't exist for this campaign's pipeline. */
export function TabNotFound({ onGoBack }: TabNotFoundProps) {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4 py-24">
      <h1 className="text-8xl font-bold text-muted-foreground">404</h1>
      <h2 className="text-heading-h6">Page not found</h2>
      <p className="text-body-sm-regular text-muted-foreground">
        This campaign doesn&apos;t have that step.
      </p>
      <Button variant="outline" onClick={onGoBack}>
        Back to Confirmed
      </Button>
    </div>
  );
}
